/**
 * Moduł zarządzający sekcją "Opinie" na karcie produktu,
 * Załadowanie formularza, obsługa zdarzeń: ocena opini, zgłoś naduzycie
 *
 * @type module
 */
app.service('productTabOpinions', function (broker, productCardConfig, opinionForm, validate, loading, modal, opinionQuestions, opinionAnswers, localStorage, cookie, message) {
	var $self, $pagingButtons, $sort, $starFilter, $opinionMarkerFilter, $opinionMarkerFilterOption, $loadGrade, $opinionStatistics, $opinionList, $starFilterOption;
	var $gradeSelect, $opinionStarsTrigger, $toggleContentButton, $voteHelpful, $opinionText;

	var grade = false, sort;
	var markers = [], loadedMarkers = [];
	var gradeText = [];
	var minCharacters = 20;

	function loadSuccess(html, hash){
		$opinionsContent.empty().html($('<div>'+html+'</div>').find('#opinions-content').html());
		setElements();
		$sortOpinionInput.select3();
		setEvents();
		updateOpinionsTabQuantity();
		updateGradeFilter();
		hideVotesFromLocalStorage();
		setOpinionToolBoxes();
		opinionQuestions.init();
		//opinionForm.init();
		opinionAnswers.init();
		loading.stop();

		if(hash){
			if( hash.indexOf('#opinia-') === 0 ) {
				var opinionId = hash.slice(8);
				$.scrollTo( '#opinion-' + opinionId );
			} else {
				var newHash = hash.slice(0, 8) + "-" + hash.slice(8);
				$.scrollTo(newHash);
			}
		} else {
			$.scrollTo($opinionList);
		}
	}
	function loadError(){
		modal.alert('Wystąpił błąd ładowania zakładki. Prosimy spróbować później');
		loading.stop();
	}
	function load(page, hash, type){
		loading.start();
		if($self.length){
			var config=productCardConfig.getData();
			var data={
				nodeid:config.nodeId,
				'product-link-name':config.linkName,
				'group-id':config.groupId,
				preview:config.preview,
				sort: type || sort,
				scrollTo:false,
				'page_nr':page
			};
			if(grade){
				data.grade=grade;
			}
			if(markers.length){
				data.opinionMarker=markers;
			}
			if(config.nodeId && config.linkName){
				loading.start();
				$.ajax({
					url:'/product-card-opinion.ltr',
					type:'GET',
					data:data,
					success:function(html){
						loadSuccess(html, hash);
					},error:function(){
						loadError();
					}
				});
			}
		}
	}
	function loadGrade(newGrade) {
		grade = newGrade;
		load(1);
	}
	function showDetailedGrades(element) {
		if($(element).parent().hasClass('expand')){
			hideAll();
		}else{
			hideAll();
			$(element).parent().addClass('expand');
		}
	}
	function hideAll(isSelect3) {
		hideDetailedGrades();
		hideFilterStars();
		hideFilterOpinionMarker();
		if(!isSelect3){
			$sortOpinionInput.select3('close');
		}
	}
	function hideDetailedGrades() {
		$self.find('.opinion-stars.expand').removeClass('expand');
	}
	function toggleOpinionContent(id) {
		$('#full-opinion' + id).addClass('text-full');
		$('#full-opinion' + id).removeClass('text-short');
	}
	function voteHelpful(type, opinionId) {
		var data={
			'opinionId': opinionId
		};
		$('#rate-box'+opinionId).addClass('voted-now');
		if(type=='yes'){
			data.helpful='helpful';
			$('#rate-box'+opinionId).addClass('voted-yes');
		}else{
			data.notHelpful='notHelpful';
			$('#rate-box'+opinionId).addClass('voted-no');
		}
		$.ajax({
			url:'/opinion-update.ltr',
			type:'POST',
			cache:false,
			data: data
		});
		updateOpinion(opinionId);

	}

	function updateOpinion(opinionId) {
		if(!cookie.isEmpty('euroOpinionVote')) {         //'cookie' do usunięcia po 100 dniach od wdrożenia
			localStorage.setItem('euroOpinionVote',cookie.split('euroOpinionVote'),100);
			cookie.remove('euroOpinionVote');
		}
		var opinionValue = localStorage.getItem('euroOpinionVote');
		if(localStorage.empty('euroOpinionVote')) {
			opinionValue='';
		}
		opinionValue=opinionValue.split("|");
		opinionValue.push(opinionId);
		localStorage.setItem('euroOpinionVote',opinionValue.join('|'),100);
	}

	function hideVotesFromLocalStorage() {
		if(!cookie.isEmpty('euroOpinionVote')) {         //'cookie' do usunięcia po 100 dniach od wdrożenia
			localStorage.setItem('euroOpinionVote',cookie.split('euroOpinionVote'),100);
			cookie.remove('euroOpinionVote');
		}
		var opinionValue = localStorage.getItem('euroOpinionVote');
		if(opinionValue !== undefined)	{
			var voted = opinionValue ? opinionValue.split('|') : '';
			$(voted).each(function(i,n){
				if(n !== '') {
					var box=$('#rate-box'+n);
					if(box.length){
						box.addClass('voted-before');
					}
				}
			});
		}
	}

	function setOpinionToolBoxes(){
	}
	function updateGradeFilter(){
		$('.filter-stars-current-visible').removeClass('filter-stars-current-visible');
		if(grade){
			$starFilter.find('.stars-rating[data-stars=' + grade + ']').addClass('filter-stars-current-visible');
		} else {
			$starFilter.find('.filter-stars-current').addClass('filter-stars-current-visible');
		}
	}
	function showForm(){
		loading.start();
		$('#add-opinion-form').removeClass('add-opinion-form-hidden');
		opinionForm.init();
	}
	function hideFilterStars(){
		$starFilter.removeClass('expand');
	}
	function hideFilterOpinionMarker(){
		resetSelectedToLoadedMarkers()
		$opinionMarkerFilter.removeClass('expand');
	}
	function isFilterOpinionMarkerChanged(){
		return (JSON.stringify(markers) != JSON.stringify(loadedMarkers));
	}
	function loadFilterOpinionMarker(){
		UA.interaction('KP', 'Opinie', 'Filtruj - Wybrane rodzaje opinii: ' + markers);
		grade=false; //reset previous grade filter
		load(1);
	}
	function updateFilterButtonState(){
		const $applyFilterButtonParent = $self.find('.opinion-filter-buttons');
		isFilterOpinionMarkerChanged() ? $applyFilterButtonParent.addClass('show-filter-apply-button') : $applyFilterButtonParent.removeClass('show-filter-apply-button');
	}
	function resetSelectedToLoadedMarkers(){
		if (isFilterOpinionMarkerChanged()) {
			$('.opinion-filter-buttons').removeClass('show-filter-apply-button'); // ukrycie przycisku filtrowania
			const $filterMarkerList = $('.opinion-filter-marker-list');
			//zaznaczenie załadowanych opcji
			markers = loadedMarkers;
			if (markers.length == 1) {
				$filterMarkerList.find('.opinion-filter-marker-option').removeClass('marker-selected marker-blocked');
				$filterMarkerList.find(`[data-marker="${markers[0]}"]`).addClass('marker-selected marker-blocked');
			} else if (markers.length > 1){
				$filterMarkerList.find('.marker-blocked').removeClass('marker-blocked');
				markers.forEach(function (marker) {
					$filterMarkerList.find(`[data-marker="${marker}"]`).addClass('marker-selected');
				});
			}
		}
	}
	function updateOpinionsTabQuantity(){
		const loadedOpinionsQuantity = $opinionStatistics.find('[data-opinions-quantity]').data('opinions-quantity');
		broker.trigger('PRODUCT_OPINION_TAB_QUANTITY_CHANGE', loadedOpinionsQuantity);
	}
	function findPageWithOpinion(){
		var config=productCardConfig.getData();
		var hash = document.location.hash;
		var id = hash.match(/\d/g);
		if(id){
			id = id.join('');
		}
		if(id > 0 && (hash.indexOf('#opinion')===0 || hash.indexOf('#opinia')===0)){
			loading.start();
			$.ajax({
				url:'/find-page-with-opinion.ltr',
				data:{
					productId:config.id,
					opinionId:id
				},
				success:function(json){
					if(json.pageNumber){
						load(json.pageNumber, hash);
					}else{
						loading.stop();
					}
				},
				error:function(){
					loading.stop();
				}
			});
		}
	}
	function setEvents(){

		$sort.on('change', function(){
			load($(this).data('js'), '', $(this).val());
			//text wybranej opcji sortowania
			UA.interaction('KP', 'Opinie', 'Sortuj - ' + $(this).siblings('.select3-selected-item').text().trim());
		});
		$pagingButtons.on('click', function(){
			load($(this).data('page'));
			//wybrana strona
			UA.interaction('KP', 'Opinie', 'Stronicowanie - ' + $(this).data('page'));
		});
		$('.js-opinion-omnibus', $self).click(function (e) {
			e.preventDefault();
			loading.start();
			message.get('omnibus-opinion-modal-message').then(function (html) { 
				loading.stop();
				modal.generate({
					id: 'opinion-omnibus-modal',
					content: html
				});
			})
		});
		$opinionStarsTrigger.on('click', function(event){
			showDetailedGrades($(this));
			event.stopPropagation();
		});
		$toggleContentButton.on('click', function(){
			toggleOpinionContent($(this).data('toggle'));
			UA.interaction('KP', 'Opinie', 'Pokaż pełną treść opinii');
		});
		$voteHelpful.on('click', function(event){
			event.preventDefault();
			voteHelpful($(this).data('helpful'), $(this).data('id'));
			if( $(this).data('helpful') === 'yes' ) {
				UA.interaction('KP', 'Opinie', 'Ocena - Przydatna');
			} else {
				UA.interaction('KP', 'Opinie', 'Ocena - Nieprzydatna');
			}
		});
		$gradeSelect.on('change',function(){
			loadGrade($(this).val());
		});
		$loadGrade.on('click', function(){
			loadGrade($(this).data('grade'));
			//wysokość oceny
			UA.interaction('KP', 'Opinie', 'Filtruj - Ocena ' + $(this).data('value'));
		});
		$starFilter.on('click',function(event) {
			if($(this).hasClass('expand')) {
				hideAll();
			}else {
				hideAll();
				$(this).addClass('expand');
			}
			event.stopPropagation();
		});
		$starFilterOption.on('click',function() {
			loadGrade($(this).data('stars'));
			//wysokość oceny
			UA.interaction('KP', 'Opinie', 'Filtruj - Ocena ' + $(this).data('value'));
		});
		$opinionMarkerFilter.on('click',function(event) {
			if($(this).hasClass('expand')) {
				hideAll();
			}else {
				hideAll();
				$(this).addClass('expand');
			}
			event.stopPropagation();
		});
		$opinionMarkerFilterOption.on('click',function(e) {
			const $option = $(this);
			const markerName = $option.data('marker');
			UA.interaction('KP', 'Opinie', 'Filtr rodzaju opinii ' + markerName + ' klikniecie ');
			if(!$option.hasClass('marker-blocked') && !$option.hasClass('marker-disabled')){
				$option.toggleClass('marker-selected');

				//aktualna lista zaznaczonych
				const $selectedOpinionMarkersList = $option.closest('.opinion-filter-marker-list').find('.marker-selected');

				if($selectedOpinionMarkersList.length == 1){//blokuje ostatnią opcję przed odznaczeniem
					$($selectedOpinionMarkersList[0]).addClass('marker-blocked');
				} else {
					$self.find('[data-marker].marker-blocked').removeClass('marker-blocked');
				}
				//aktualizacja zaznaczonych
				markers = [];
				$selectedOpinionMarkersList.each((i,element) => {
					markers.push(element.dataset.marker);
				});
			}
			updateFilterButtonState();
		});
		$opinionMarkerFilterApplyButton.on('click',function(e) {
			loadFilterOpinionMarker();
		});
		$opinionText.each(function(){
			if( $(this).height() <= $(this).data('max-length') ){
				$(this).addClass('text-full');
			} else {
				$(this).addClass('text-short');
			}
		});

	}
	function setElements(){
		$self = $('#opinions');
		$opinionsContent = $('#opinions-content', $self);
		$sort = $('.sort-opinions input', $self);
		$opinionList=$('#opinion-list', $self);
		$opinionStatistics = $('.opinion-statistics', $self);
		$pagingButtons = $('.js-btn-paging', $self);
		$loadGrade = $('.js-load-grade-opinion:not(.grade-no-results)', $self);
		$opinionStarsTrigger = $('.js-opinion-stars', $self);
		$toggleContentButton = $('.js-toggle-content', $self);
		$voteHelpful = $('.js-opinion-helpful', $self);
		$gradeSelect = $('#grade-select', $self);
		$starFilter = $('.js-opinion-filter-stars', $self);
		$starFilterOption = $('.js-opinion-filter-stars-option', $self);
		$opinionMarkerFilter = $('.js-opinion-filter-marker', $self);
		$opinionMarkerFilterOption = $('.js-opinion-filter-marker-option:not(.marker-disabled)', $self);
		$opinionMarkerFilterApplyButton = $('.js-opinion-filter-apply-button', $self);
		$opinionText = $('.opinion-text', $self);
		$sortOpinionInput = $('.sort-opinions input');
		if($opinionsContent.length){
			grade = $('#opinion-grade').val();
			grade = grade != '' ? grade/1 : false;
			sort = $('#opinion-sort').val();
			markers = loadedMarkers = $('#opinion-markers').val().split('|'); //wyrownanie wartosci na zaladowanie
		}
	}
	function init(){
		setElements();
		$self.on('click','.js-add-opinion', function(){
			UA.interaction('KP', 'Opinie', 'Dodaj opinię');
			opinionForm.load();
		}).on('click', function(event){
			if($(event.target).closest('.js-opinion-filter-marker-option').length) {
				//lista wielokrotnego wyboru
			}else if($(event.target).closest('.sort-select').length){
				//select3
				hideAll(true);
			}else{
				hideAll();
			}
		});

		setEvents();
		opinionQuestions.init();
		opinionAnswers.init();
		hideVotesFromLocalStorage();
		setOpinionToolBoxes();
		findPageWithOpinion();
		opinionForm.init();
	}
	return {
		init:init
	};
});
